module.exports = __webpack_public_path__ + "e5a1dd440b0dfab7fcd0a67667825fdc.svg";